"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const lp_components_1 = require("lp-components");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const apiActions = __importStar(require("api-actions"));
const local_storage_1 = require("local-storage");
const utils_1 = require("utils");
const merchantActions = __importStar(require("../../actions"));
const forms_1 = require("../../forms");
const reducer_1 = require("../../reducer");
const SalesConfirmationTable_1 = __importDefault(require("./SalesConfirmationTable"));
function SalesConfirmationModal({ handleSubmitSuccess, currentLocation, paymentDetails, lenderSettings, currentLocationIndex, setCurrentLocationIndex, onCompleteSaleClick, handleClose, plan, allLocations, fetchLocationDetails, }) {
    const { name, alphaeonAccountNumber, amount, buyer, consumerCreditInstrumentType, serviceDate, lineItems, } = paymentDetails;
    const [displayLocationSelector, setDisplayLocationSelector] = (0, react_1.useState)(false);
    const closeLocationSelector = () => setDisplayLocationSelector(false);
    const isInstallmentProduct = consumerCreditInstrumentType === 'installment';
    const shouldDisplayChangeLocationButton = !isInstallmentProduct;
    const showSaleInText = lenderSettings?.lenderProductType != 'LTO';
    const SALE_TEXT = showSaleInText
        ? 'Confirm Sale Transaction Details'
        : 'Confirm Transaction Details';
    return ((0, jsx_runtime_1.jsxs)(lp_components_1.Modal, { className: "fit-auto", onClose: () => {
            handleClose();
        }, hideCloseButton: true, children: [(0, jsx_runtime_1.jsx)(SalesConfirmationTable_1.default, { plan: plan, lenderSettings: lenderSettings, currentLocation: currentLocation, SALE_TEXT: SALE_TEXT, buyer: buyer, lineItems: lineItems, amount: amount, name: name, alphaeonAccountNumber: alphaeonAccountNumber, isInstallmentProduct: isInstallmentProduct, serviceDate: serviceDate, onCompleteSaleClick: onCompleteSaleClick, handleSubmitSuccess: handleSubmitSuccess, shouldDisplayChangeLocationButton: shouldDisplayChangeLocationButton, displayLocationSelector: displayLocationSelector, setDisplayLocationSelector: setDisplayLocationSelector }), displayLocationSelector && ((0, jsx_runtime_1.jsx)(lp_components_1.Modal, { onClose: closeLocationSelector, children: (0, jsx_runtime_1.jsx)(forms_1.LocationSelectorForm, { allLocations: allLocations, initialValues: { selectedLocationIndex: currentLocationIndex }, defaultValue: {
                        label: currentLocation.name,
                        value: currentLocationIndex,
                    }, onSubmit: ({ selectedLocationIndex, }) => {
                        closeLocationSelector();
                        fetchLocationDetails(allLocations[selectedLocationIndex.value].locationId).then((res) => (0, local_storage_1.setLocation)(res));
                        return setCurrentLocationIndex(selectedLocationIndex.value);
                    } }) }))] }));
}
function mapStateToProps(state) {
    return {
        currentLocation: reducer_1.selectors.currentLocation(state),
        allLocations: reducer_1.selectors.allLocations(state),
        currentLocationIndex: reducer_1.selectors.currentLocationIndex(state),
    };
}
const mapDispatchToProps = {
    setCurrentLocationIndex: merchantActions.setCurrentLocationIndex,
};
const mapApiAuthToProps = {
    fetchLocationDetails: apiActions.fetchLocationDetails,
};
exports.default = (0, redux_1.compose)((0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), (0, utils_1.withApiAuth)(mapApiAuthToProps))(SalesConfirmationModal);
